import { useMutation } from "@apollo/client/react";
import { VALIDATE_MANUALLY } from "../../mutations/invoices/validateManually";
import GET_INVOICE_LATEST_VALIDATION_RESULT from "../../queries/invoices/getInvoiceLatestValidationResult";

export const useValidateManually = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [validateManually, { data, loading, error }] = useMutation(
    VALIDATE_MANUALLY,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_INVOICE_LATEST_VALIDATION_RESULT],
      awaitRefetchQueries: true,
    },
  );

  return { validateManually, data, loading, error };
};
